import React from 'react';

import cl from './SavingAccounts.module.css'

import savingAccountChooseImg1 from '../../../assets/images/savingAccountsChooseItem1.svg'
import savingAccountChooseImg2 from '../../../assets/images/savingAccountsChooseItem2.svg'
import savingAccountChooseImg3 from '../../../assets/images/savingAccountsChooseItem3.svg'
import savingAccountChooseImg4 from '../../../assets/images/savingAccountsChooseItem4.svg'

import getStartedImg1 from '../../../assets/images/getStartedImg1.png'
import getStartedImg2 from '../../../assets/images/getStartedImg2.png'

import savingProtectorImg from '../../../assets/images/savingProtectorImg.png'

import { NavLink } from 'react-router-dom';



const SavingAccounts = () => {
    return (
        <>
        <div className={cl.saving_accounts_container}>
            <h2 className={cl.saving_accounts_title}>
                Savings Accounts
            </h2>
            <div className={cl.saving_accounts_description_wrapper}>
                <p className={cl.saving_accounts_description}>
                    Smarter savings for every goal. Choose from flexible, secure accounts with standout returns—whether you’re saving for near-term plans or building long-term wealth.
                </p>
            </div>
            <div className={cl.saving_accounts_concept_row}>
                <div className={cl.saving_account_concept_item}>
                    <h3 className={cl.saving_account_concept_title}>
                        12%
                    </h3>
                    <p className={cl.saving_account_concept_descr}>
                        Interest on your savings — grow your money with confidence!
                    </p>
                </div>
                 <div className={cl.saving_account_concept_item}>
                    <h3 className={cl.saving_account_concept_title}>
                        €500
                    </h3>
                    <p className={cl.saving_account_concept_descr}>
                        Minimum deposit — open your savings account today
                    </p>
                </div>
            </div>
        </div>
        <div className={cl.saving_account_choose_background}>
            <div className={cl.saving_account_choose_container}>
                <h2 className={cl.saving_accounts_choose_title}>
                    WHY CHOOSE FORTRES BANCORP SAVINGS ACCOUNTS?
                </h2>
                <div className={cl.saving_accounts_choose_row}>
                    <div className={cl.saving_accounts_choose_item}>
                        <div className={cl.saving_accounts_choose_img_wrapper}>
                            <img src={savingAccountChooseImg1} alt="" />
                        </div>
                        <h3 className={cl.saving_account_choose_title}>
                            Free Debit Card
                        </h3>
                        <p className={cl.saving_account_choose_descr}>
                            Instant access to your funds anytime, anywhere.
                        </p>
                    </div>
                    <div className={cl.saving_accounts_choose_item}>
                        <div className={cl.saving_accounts_choose_img_wrapper}>
                            <img src={savingAccountChooseImg2} alt="" />
                        </div>
                        <h3 className={cl.saving_account_choose_title}>
                            Competitive Fixed Returns
                        </h3>
                        <p className={cl.saving_account_choose_descr}>
                           Grow your balance faster with high annual   interest rates.
                        </p>
                    </div>
                    <div className={cl.saving_accounts_choose_item}>
                        <div className={cl.saving_accounts_choose_img_wrapper}>
                            <img src={savingAccountChooseImg3} alt="" />
                        </div>
                        <h3 className={cl.saving_account_choose_title}>
                            Secure & Regulated
                        </h3>
                        <p className={cl.saving_account_choose_descr}>
                            Your funds are protected under our fully compliant financial framework.
                        </p>
                    </div>
                    <div className={cl.saving_accounts_choose_item}>
                        <div className={cl.saving_accounts_choose_img_wrapper}>
                            <img src={savingAccountChooseImg4} alt="" />
                        </div>
                        <h3 className={cl.saving_account_choose_title}>
                            No Hidden Fees
                        </h3>
                        <p className={cl.saving_account_choose_descr}>
                             Transparent, straightforward banking for every client.
                        </p>
                    </div>
                </div>
           </div>
        </div>
        <div className={cl.get_started_container}>
            <div className={cl.left_get_started}>
                <h2 className={cl.left_get_started_title}>
                    Get Started Today
                </h2>
                <div className={cl.left_get_started_descr_wrapper}>
                    <p className={cl.left_get_started_descr}>
                        Join Fortres BanCorp and open your savings account with a deposit of €500 or more. Start earning exceptional interest rates and enjoy exclusive customer benefits — all while keeping your money safe and accessible.
                    </p>
                </div>
                <NavLink to='/sign-up'>
                    <div className={cl.open_account_blue}>
                        Open Account
                    </div>
                </NavLink>
            </div>
            <div className={cl.right_get_started}>
                <img src={getStartedImg1} alt="" className={cl.get_started_img1} />
                <img src={getStartedImg2} alt="" className={cl.get_started_img2}/>
                <div className={cl.price_section}>
                    <h4 className={cl.price_section_title}>
                        €500
                    </h4>
                    <p className={cl.price_description}>
                        Open a savings account
                    </p>
                </div>
            </div>
        </div>
        <div className={cl.saving_protector_background}>
            <div className={cl.saving_protector_container}>
                <div className={cl.saving_protector_left}>
                    <img src={savingProtectorImg} alt="" />
                </div>
                <div className={cl.saving_protector_right}>
                    <h2 className={cl.saving_protector_title}>
                        How Are My Savings Protected?
                    </h2>
                    <div className={cl.saving_protector_descr_wrapper}>
                        <p className={cl.saving_protector_descr}>
                            All Fortres BanCorp savings accounts are protected by the MISA, providing automatic security for your deposits. You can confidently manage your funds knowing they are fully secured under our regulated financial framework.
                        </p>
                    </div>
                    <NavLink to='/sign-up'>
                        <div className={cl.open_account_white}>
                            Open Account
                        </div>
                    </NavLink>
                </div>
            </div>
        </div>
        </>
    );
};

export default SavingAccounts;